<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
        <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
          <el-row>
            <el-col :span="6">
              <el-input size="medium" placeholder="搜索关键字: " v-model="key" style="width: 97%;"></el-input>
            </el-col>
            <el-col :span="7">
              <el-button size="medium" type="primary" icon="el-icon-search">搜索</el-button>
            </el-col>
            <el-col :span="9">
              &nbsp;
            </el-col>
            <el-col :span="2">
              <el-button size="medium" type="success" @click="openDialog('add', null)"
                v-if="checkButtonPermission('front:manage:advertise:add')">新增广告</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
      <div>
        <el-table :data="tableData" border fixed height="400" style="width: 100%">
          <el-table-column prop="image" label="图片" min-width="70">
            <template slot-scope="scope" v-if="undefined != scope.row.image && '' != scope.row.image">
              <img width="32" height="32" :src="scope.row.image" />
            </template>
          </el-table-column>
          <el-table-column prop="advertisementCategory" label="类型" min-width="70">
            <template slot-scope="scope">
              <span v-if="scope.row.advertisementCategory == 0">导购</span>
              <span v-else-if="scope.row.advertisementCategory == 1">车贷</span>
              <span v-else-if="scope.row.advertisementCategory == 2">静态</span>
              <span v-else-if="scope.row.advertisementCategory == 3">公众号文章</span>
              <span v-else-if="scope.row.advertisementCategory == 4">文章</span>
              <span v-else-if="scope.row.advertisementCategory == 5">海报</span>
              <span v-else-if="scope.row.advertisementCategory == 6">图片</span>
              <span v-else-if="scope.row.advertisementCategory == 7">缤纷购车节</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="时间" min-width="70"></el-table-column>
          <el-table-column prop="moduleAdvertise" label="模块广告" min-width="70">
            <template slot-scope="scope">
              <span v-if="scope.row.moduleAdvertise == 'index'">首页</span>
              <span v-else-if="scope.row.moduleAdvertise == 'recommend'">为你推荐</span>
              <span v-else-if="scope.row.moduleAdvertise == 'guide'">导购</span>
              <span v-else-if="scope.row.moduleAdvertise == 'car_loan'">车贷</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="120" fixed="right">
            <template slot-scope="scope">
              <el-button type="success" size="mini" @click="openDialog('edit', scope.row)"
                v-if="checkButtonPermission('front:manage:advertise:edit')">编辑
              </el-button>
              <el-button @click="deleteAdverise(scope.row.advertisementId)" type="danger" size="mini"
                v-if="checkButtonPermission('front:manage:advertise:delete')">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 18px 0px; float: right;">
          <el-pagination background @current-change="currentPageChange" @size-change="pageSizeChange"
            :current-page="currentPage" :page-sizes="[5, 10, 20, 50, 100]" :page-size="pageSize" :page-count="totalPage"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog title="广告" :visible.sync="dialogVisible" @closed="resetForm('advertiseForm')" :modal="false"
      :close-on-click-modal="false">
      <el-form :model="advertiseForm" ref="advertiseForm" :rules="advertiseFormRules" label-width="120px" size="medium"
        style="padding: 0 10%;">
        <el-form-item label="图片" prop="image">
          <el-upload ref="upload" :file-list="fileList" :action="this.env.env.uploadUrl" list-type="picture-card"
            :limit="1" :on-success="uploadAdvertiseImageSuccess" :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="模块广告位置" prop="moduleAdvertise">
          <el-select v-model="advertiseModuleSelect" @change="handleAdvertiseModuleChange">
            <el-option v-for="option in advertiseModules" :label="option.label" :value="option.value"
              :key="option.value" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="advertiseCategory" label="类型" prop="advertisementCategory">
          <el-select v-model="categorySelect" @change="handleStatusChange">
            <el-option v-for="option in categorySelectOptions" :label="option.label" :value="option.value"
              :key="option.value" />
          </el-select>
        </el-form-item>

        <el-form-item v-if="linkFlag" label="链接地址" prop="actionVal">
          <el-input v-model="linkVal" placeholder="请输入链接地址" size="medium" clearable></el-input>
        </el-form-item>

        <el-form-item v-if="articleFlag" label="文章" prop="actionVal">
          <el-select v-model="articleSelect" @change="handleArticleChange">
            <el-option v-for="article in articles" :label="article.title" :value="article.articleId"
              :key="article.articleId" />
          </el-select>
        </el-form-item>

        <el-form-item v-if="posterFlag" label="海报" prop="actionVal">
          <el-select v-model="posterSelect" @change="handlePosterChange">
            <el-option v-for="poster in posters" :label="poster.title" :value="poster.posterId"
              :key="poster.posterId" />
          </el-select>
        </el-form-item>

        <el-form-item v-if="picFlag" label="标题" prop="actionVal">
          <el-input v-model="pageTitle" placeholder="请输入标题" size="medium" clearable></el-input>
        </el-form-item>

        <el-form-item v-if="picFlag" label="详情图片" prop="image">
          <el-upload ref="uploadP" :file-list="picList" :action="this.env.env.uploadUrl" list-type="picture-card"
            :limit="1" :on-success="uploadAdvertisePicSuccess" :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>

        <el-form-item v-if="advertiseCategory" label="视频">
          <div class="image-wrap" v-if="pageVideo">
            <video style="width: 300px;" name="upfile" :src="pageVideo" class="avatar"
              controls="controls">您的浏览器不支持视频播放</video>
            <div
              style="color: red; border: 1px solid red; border-radius: 5px; text-align: center; width: 200px; cursor: pointer;"
              @click="() => {
                this.pageVideo = '';
              }">删除视频</div>
          </div>
          <el-upload v-else v-loading="videoLoading" ref="upload2" :file-list="fileList2"
            :action="this.env.env.uploadUrl" :list-type="pageVideo ? '' : 'picture-card'" :limit="1"
            :on-progress="uploadVideoProcess" :on-success="uploadAdvertiseVideoSuccess">
            <i class="el-icon-plus" v-loading="videoLoading"><span v-if="videoLoading">上传中</span></i>
          </el-upload>
        </el-form-item>

        <el-form-item size="large">
          <el-button @click="dialogVisible = false">&nbsp;&nbsp;&nbsp;取&nbsp;&nbsp;消&nbsp;&nbsp;&nbsp;</el-button>
          <el-button type="primary"
            @click="submitForm('advertiseForm')">&nbsp;&nbsp;&nbsp;确&nbsp;&nbsp;定&nbsp;&nbsp;&nbsp;</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="imageDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { reqCode, dialogAction } from '@/common/const';
export default {
  name: "advertiseList",
  data() {
    return {
      key: '',
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      totalPage: 0,
      total: 0,
      dialogVisible: false,
      dialogImageUrl: '',
      imageDialogVisible: false,
      categorySelect: '',
      categorySelectVal: -1,
      categorySelectOptions: [
        {
          label: '导购',
          value: 0,
        }, {
          label: '车贷',
          value: 1,
        }, {
          label: '静态',
          value: 2,
        }, {
          label: '公众号文章',
          value: 3,
        }, {
          label: '文章',
          value: 4,
        }, {
          label: '海报',
          value: 5,
        }, {
          label: '图片',
          value: 6,
        }, {
          label: '缤纷购车节',
          value: 7,
        }
      ],
      advertiseForm: {},
      advertiseFormRules: {},
      advertiseModules: [
        {
          label: '首页',
          value: 'index'
        }, {
          label: '导购',
          value: 'guide'
        }, {
          label: '车贷',
          value: 'car_loan'
        }
      ],
      advertiseModuleSelect: '',
      advertiseModuleSelectVal: -1,
      uploadImage: '',
      fileList: [],
      fileList2: [],
      advertiseCategory: true,
      linkFlag: false,
      linkVal: '',
      actionFlag: false,
      popularizeFlag: false,
      articleFlag: false,
      articleSelect: '请选择文章',
      articleSelectVal: -1,
      articles: [],
      posterFlag: false,
      posterSelect: '',
      posterSelectVal: -1,
      posters: [],
      picFlag: false,
      pageTitle: '',
      uploadPic: '',
      picList: [],
      pageVideo: '',
      videoLoading: '',
    }
  },
  created() {
    this.getAdvertise();
  },
  methods: {
    getPoster() {
      let reqParam = {
        key: '',
        size: 10000
      };
      this.$http.post('/api/popularize/poster/search', reqParam).then(resp => {
        console.log(resp);
        let data = resp.data;
        if ("success" === data.code) {
          let pageInfo = data.pageInfo;
          this.posters = pageInfo.list;
        } else {
          this.$alert('' + data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    getArticle() {
      let reqParam = {
        key: ''
      };
      this.$http.post('/api/popularize/article/search', reqParam).then(resp => {
        console.log(resp);
        let data = resp.data;
        if ("success" === data.code) {
          this.articles = data.pageInfo.list;
        } else {
          this.$alert('' + data.message, '温馨提示', {
            confirmButtonText: '确定'
          });
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    handlePosterChange(val) {
      this.posterSelectVal = val;
    },
    handleArticleChange(val) {
      this.articleSelectVal = val;
    },
    uploadAdvertiseImageSuccess(resp, file, list) {
      if (reqCode.SUCCESS == resp.code) {
        this.uploadImage = resp.data;
      } else {
        this.$message({
          message: '上传文件失败：' + resp.message,
          type: 'error'
        });
      }
    },
    uploadAdvertisePicSuccess(resp, file, list) {
      if (reqCode.SUCCESS == resp.code) {
        this.uploadPic = resp.data;
      } else {
        this.$message({
          message: '上传文件失败：' + resp.message,
          type: 'error'
        });
      }
    },
    uploadVideoProcess(event, file, fileList) {
      this.videoLoading = event.percent;
    },
    uploadAdvertiseVideoSuccess(resp, file, list) {
      if (reqCode.SUCCESS == resp.code) {
        this.pageVideo = resp.data;
        this.videoLoading = '';
      } else {
        this.$message({
          message: '上传文件失败：' + resp.message,
          type: 'error'
        });
      }
    },
    getAdvertise() {
      let reqParam = {
        currentPage: this.currentPage,
        size: this.pageSize,
        key: this.key,
      };
      this.$http.post('/api/front-service/advertise/search', reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        let data = resp.data;
        console.log(data)
        if ("success" == data.code) {
          let pageInfo = data.pageInfo;
          this.tableData = pageInfo.list;
          this.pageSize = pageInfo.pageSize;
          this.total = pageInfo.total;
          this.totalPage = pageInfo.pages;
        }
      }).catch(e => {
      })
    },
    currentPageChange(val) {
      this.currentPage = val;
    },
    pageSizeChange(val) {
      this.pageSize = val;
    },
    openDialog(addFlag, data) {
      this.pageVideo = '';

      if ('add' == addFlag) {
        this.addFlag = 'add';
      }

      else if ('edit') {
        this.addFlag = 'edit';
        this.linkFlag = false;
        this.articleFlag = false;
        this.posterFlag = false;
        this.picFlag = false;
        // 绑定数据
        let tmp = {};
        Object.assign(tmp, data);
        this.advertiseForm = tmp;
        this.categorySelectVal = tmp.advertisementCategory;
        this.advertiseModuleSelectVal = tmp.moduleAdvertise;
        this.advertiseForm.image = tmp.image;
        this.uploadImage = tmp.image;
        let imgObj = new Object();
        imgObj.url = tmp.image;
        this.fileList.push(imgObj)

        this.advertiseForm.pagePic = tmp.pagePic;
        this.uploadPic = tmp.pagePic;
        this.pageVideo = tmp.pageVideo || '';
        let picObj = new Object();
        picObj.url = tmp.pagePic;
        this.picList.push(picObj)

        // image: '',
        let category = tmp.advertisementCategory;
        if (0 == category) {
          this.categorySelect = '导购';
        } else if (1 == category) {
          this.categorySelect = '车贷';
        } else if (2 == category) {
          this.categorySelect = '静态';
        } else if (3 == category) {
          this.categorySelect = '公众号文章';
          this.linkVal = tmp.actionVal;
          this.linkFlag = true;
        } else if (4 == category) {
          this.categorySelect = '文章';
          this.articleSelectVal = tmp.actionVal;
          this.articleFlag = true;
        } else if (5 == category) {
          this.getPoster();
          this.categorySelect = '海报';
          this.posterSelectVal = tmp.actionVal;
          this.posterSelect = tmp.actionVal;
          this.posterFlag = true;
        } else if (6 == category) {
          this.categorySelect = '图片';
          this.pageTitle = tmp.pageTitle;
          this.picFlag = true;
        } else if (7 == category) {
          this.categorySelect = '缤纷购车节';
        }
        this.categorySelectVal = category;

        let modulePosition = tmp.moduleAdvertise;
        if ('index' == modulePosition) {
          this.advertiseModuleSelect = '首页';
        } else if ('recommend' == modulePosition) {
          this.advertiseModuleSelect = '为你推荐';
        } else if ('guide' == modulePosition) {
          this.advertiseModuleSelect = '导购';
        } else if ('car_loan' == modulePosition) {
          this.advertiseModuleSelect = '车贷';
        }
        this.advertiseModuleSelect = modulePosition;

      }

      this.dialogVisible = true;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imageDialogVisible = true;
    },
    resetForm(formName) {
      this.fileList = [];
      this.fileList2 = [];
      this.uploadImage = '';
      this.categorySelect = '';
      this.categorySelectVal = -1;
      this.advertiseModuleSelectVal = -1;
      this.advertiseModuleSelect = '';
      this.advertiseForm = {};
      this.$refs.upload.clearFiles();
      this.articles = [];
      this.posters = [];
      this.articleFlag = false;
      this.posterFlag = false;
      this.articleSelect = '请选择文章';
      this.articleSelectVal = -1;
      this.posterSelect = '请选择海报';
      this.posterSelectVal = -1;
      this.$refs[formName].resetFields();
      this.picList = [];
      this.$refs.uploadPic.clearFiles();
    },
    submitForm(formName) {
      // 1.判断是新增还是编辑，然后发送请求
      if ('add' == this.addFlag) {
        let reqParam = {
          image: this.uploadImage,
          advertisementCategory: this.categorySelectVal,
          moduleAdvertise: this.advertiseModuleSelectVal,
        };

        // 传公众号文章参数
        if (3 == this.categorySelectVal && 'index' == this.advertiseModuleSelectVal) {
          reqParam.actionVal = this.linkVal;
        }

        // 传文章参数
        if (4 == this.categorySelectVal && 'index' == this.advertiseModuleSelectVal) {
          reqParam.actionVal = this.articleSelectVal;
        }

        // 传海报参数
        if (5 == this.categorySelectVal && 'index' == this.advertiseModuleSelectVal) {
          reqParam.actionVal = this.posterSelectVal;
        }

        // 传图片参数
        if (6 == this.categorySelectVal && 'index' == this.advertiseModuleSelectVal) {
          reqParam.pageTitle = this.pageTitle;
          reqParam.pagePic = this.uploadPic;
        }

        reqParam.pageVideo = this.pageVideo;

        this.addAdverise(formName, reqParam);
      } else if ('edit' == this.addFlag) {
        let reqParam = {
          advertisementId: this.advertiseForm.advertisementId,
          image: this.uploadImage,
          advertisementCategory: this.categorySelectVal,
          moduleAdvertise: this.advertiseModuleSelectVal,
        };

        // 传公众号文章参数
        if (3 == this.categorySelectVal && 'index' == this.advertiseModuleSelectVal) {
          reqParam.actionVal = this.linkVal;
        }

        // 传文章参数
        if (4 == this.categorySelectVal && 'index' == this.advertiseModuleSelectVal) {
          reqParam.actionVal = this.articleSelectVal;
        }

        // 传海报参数
        if (5 == this.categorySelectVal && 'index' == this.advertiseModuleSelectVal) {
          reqParam.actionVal = this.posterSelectVal;
        }

        // 传图片参数
        if (6 == this.categorySelectVal && 'index' == this.advertiseModuleSelectVal) {
          reqParam.pageTitle = this.pageTitle;
          reqParam.pagePic = this.uploadPic;
        }

        reqParam.pageVideo = this.pageVideo;

        this.updateAdverise(formName, reqParam);
      }
      // 2.提示用户请求状态
    },
    addAdverise(formName, reqParam) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post('/api/front-service/advertise/add', reqParam, {
            headers: {
              accessToken: sessionStorage.getItem('accessToken')
            }
          }).then(resp => {
            let data = resp.data;
            if ('success' == data.code) {
              this.getAdvertise();
              this.$message({
                message: '新增广告成功',
                type: 'success'
              });
              // 3.关闭模态框
              this.dialogVisible = false;
              this.resetForm(formName);
            }
          }).catch(e => {
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    updateAdverise(formName, reqParam) {

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post('/api/front-service/advertise/update', reqParam, {
            headers: {
              accessToken: sessionStorage.getItem('accessToken')
            }
          }).then(resp => {
            let data = resp.data;
            if (data.code === "success") {
              this.$message({
                message: '编辑广告成功',
                type: 'success'
              });
              this.dialogVisible = false;
              this.getAdvertise();
            } else {
              this.$alert('' + data.message, '温馨提示', {
                confirmButtonText: '确定'
              });
            }
          }).catch(e => {
            this.$alert('' + e, '温馨提示', {
              confirmButtonText: '确定'
            });
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });

      // 3.关闭模态框
      this.dialogVisible = false;
    },
    deleteAdverise(advertiseId) {
      this.$confirm('此操作将永久该海报, 是否继续?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/api/front-service/advertise/delete?advertiseId=' + advertiseId, {}, {
          headers: {
            accessToken: sessionStorage.getItem('accessToken')
          }
        }).then(resp => {
          let data = resp.data;
          if (data.code === "success") {
            this.dialogVisible = false;
            this.$message({
              message: '删除广告成功',
              type: 'success'
            });
            this.getAdvertise();
          } else {
            this.$alert('' + data.message, '温馨提示', {
              confirmButtonText: '确定'
            });
          }
        }).catch(e => {
          this.$alert('' + e, '温馨提示', {
            confirmButtonText: '确定'
          });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleStatusChange(val) {
      this.categorySelectVal = val;
      if (3 == val && 'index' == this.advertiseModuleSelectVal) {
        this.linkFlag = true;
      } else {
        this.linkFlag = false;
      }

      if (4 == val && 'index' == this.advertiseModuleSelectVal) {
        this.getArticle();
        this.articleFlag = true;
      } else {
        this.articles = [];
        this.posters = [];
        this.articleFlag = false;
      }

      if (5 == val && 'index' == this.advertiseModuleSelectVal) {
        this.getPoster();
        this.posterFlag = true;
      } else {
        this.articles = [];
        this.posters = [];
        this.posterFlag = false;
      }

      if (6 == val && 'index' == this.advertiseModuleSelectVal) {
        this.picFlag = true;
      } else {
        this.picFlag = false;
      }
    },
    handleAdvertiseModuleChange(val) {
      this.advertiseModuleSelectVal = val;
      if (val && 'index' == val) {
        this.advertiseCategory = true;
      } else {
        this.advertiseCategory = false;
      }
    },
    checkButtonPermission(perms) {
      let menuPermsList = sessionStorage.getItem("menuPermsList");
      if (menuPermsList.indexOf(perms) != -1) {
        return true
      } else {
        return false;
      }
    }
  }

}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/front/advertiseList.vue